import React from "react";
import { NativeSelect } from "@mui/material";
import { makeStyles } from "@mui/styles";
import FilledInput from "@mui/material/FilledInput";
import moment from "moment-timezone";

/* styles used in TimezoneList */
const useStyles = makeStyles({
    field: {
        width: "100%"
    },
    select: {
        backgroundColor: "white",
        paddingLeft: "14px",
        borderRadius: "4px",
        "&.MuiInputLabel-root": {
            display: "none"
        },
        "& fieldset": {
            "& legend": {
                width: "unset"
            }
        },
        paddingTop: "10px"
    }
});

export const TimezoneList = ({ value, onChange }) => {
    const classes = useStyles();
    const timezoneMenuItems = moment.tz.names();

    return (
        <NativeSelect
            id="timezone-input-select"
            className={classes.field}
            label="Time Zone"
            value={value}
            onChange={onChange}
            input={
                <FilledInput
                    sx={{
                        backgroundColor: "white",
                        border: "1px solid #b5b5b5",
                        borderRadius: "4px",
                        height: "2.688em"
                    }}
                    InputProps={{
                        disableUnderline: true
                    }}
                    inputProps={{ className: classes.select }}
                />
            }
            InputProps={{
                disableUnderline: true
            }}
        >
            {timezoneMenuItems.map((tz) => (
                <option key={tz} value={tz}>
                    {tz}
                </option>
            ))}
        </NativeSelect>
    );
};
